export const AUTH_URI = "https://authserver.endersgate.app/auth";
